import { createRankingModel } from 'models/RankingModel';
export default createRankingModel;
